import { render, staticRenderFns } from "./detailed-info-query.vue?vue&type=template&id=69f3f7f0&scoped=true"
import script from "./detailed-info-query.vue?vue&type=script&lang=ts"
export * from "./detailed-info-query.vue?vue&type=script&lang=ts"
import style0 from "./detailed-info-query.vue?vue&type=style&index=0&id=69f3f7f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f3f7f0",
  null
  
)

export default component.exports